import {Component, OnInit} from '@angular/core';
import Swal from 'sweetalert2'
import {SwalHelper} from '../helpers/swal.helper';

@Component({
    selector: 'app-having',
    templateUrl: './having.component.html',
    styleUrls: ['./having.component.css']
})
export class HavingComponent implements OnInit {
    myAssets = [new Asset()];
    swalOptions = new SwalHelper();
    constructor() { }

    ngOnInit() {
        this.myAssets[0] = {name:'Cihazlar', TotalCount: 3,AlertCount:10};
        this.myAssets[1] = {name:'Sim-Kartlar', TotalCount: 4,AlertCount:20};
        this.myAssets[2] = {name:'Beacon', TotalCount: 5,AlertCount:30};
        this.myAssets[3] = {name:'POS', TotalCount: 6,AlertCount:40};
        //this.myAssets[4] = {name:'Modem', TotalCount: 2,AlertCount:50};
    }

    deleteWarning() {
        Swal.fire({
            ...this.swalOptions.delete,
            text: 'Silmek istediğine emin misin!'
          });
    }

    notifications() {
        Swal.fire({
            ...this.swalOptions.info,
            text: 'bu uyarılar müdahalenizi gerektirebilir!'
          });
    }

}

export class Asset {
    name: string;
    TotalCount: number;
    AlertCount: number;
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/having/having.component.ts